(function($, B) {
    'use strict';
    B.web.toInit['hover'] = true;
    B.web.widgets['hover'] = {
        enabled: false,
        selectors: {
            hovers: '[data-hover]'
        },
        $elements:{
        },
        data:{           
        },
        init:function(){
            var that = this;
            Bajt.web.getElements(this.selectors, this.$elements);
            if(this.$elements.hovers){
                this.enabled = true;
                this.$elements.hovers.each(function(){
                    that.initHover($(this));
                });
            }
        },
        initHover:function($el){
            var opt = $el.data();  
            $($el).hover(function() {
                $($el).addClass(opt.hover);
            
            }, function() {
                $($el).removeClass(opt.hover);
            });      
        }


    };

})(jQuery, Bajt);